<template>
  <h1 id="title" :class="{'show' : show || $route.name === 'Lab'}">Baptiste Villain</h1>
</template>

<script>

import {mapGetters} from 'vuex'

export default {
  name: 'Title',
  computed: {
    ...mapGetters({
      show: 'show'
    })
  },
}
</script>

<style lang="scss">
  #title{
    position: fixed;
    z-index: 150;
    top: var(--body-padding);
    left: var(--body-padding);
    margin: 0;
    font-family: var(--editor);
    // font-family: var(--conduitITC);
    font-size: 1.6rem;
    font-weight: 600;
    text-transform: capitalize;
    color: var(--black);
    &.show{
      color: var(--white);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Title.vue